import { RecurringDeposits } from "../../../Pages/Recurring Deposits";

import { getRecurringDepositDefaultPreferences } from "../../../Utils/helpers";
import { modalVariants } from "../../../Utils/constants";

export default function renderGetRecurringDepositPreferences(modalContext, props) {
  const {
    updateModalComponent,
    pushModalStack,
    updateModalFormDefaultValues,
    setModalTitle,
    setModalClassName,
    setModalVariant,
  } = modalContext;

  const { initialValues, ...componentProps } = props;

  updateModalComponent(() => <RecurringDeposits settingUpRecurringDeposit {...componentProps} />);
  pushModalStack(() => renderGetRecurringDepositPreferences(modalContext, props));
  updateModalFormDefaultValues(initialValues ?? getRecurringDepositDefaultPreferences());
  setModalTitle("Recurring Deposit");
  setModalClassName("recurring-deposit-modal hide-back-button");
  setModalVariant(modalVariants.flexDialog);
}
